import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TCountryStore,
	TCountryListResponsePayload,
	TCountryDetails,
	TCountryIdRequest,
	TCountryManagementRequest,
	TCountryPagedListResponse,
	TUpdateCountryRequest,
} from './types';

// ==========================================:
export const initialState: TCountryStore = {
	countryList: null,
	countryListLoading: false,

	countryPagedList: null,
	countryPagedListLoading: false,
	countryLastListParams: null,
	countryDetails: null,
	countryDetailsLoading: false,
	countrySaveLoading: false,
	countrySaveSuccess: false,
};

// ==========================================:
const country = createSlice({
	name: '@@country',
	initialState,
	reducers: {
		getCountryListRequest: (state: TCountryStore) => {
			const countryState = state;
			countryState.countryListLoading = true;
		},
		getCountryListSuccess: (
			state: TCountryStore,
			action: PayloadAction<TCountryListResponsePayload>,
		) => {
			const { payload } = action;
			const countryState = state;
			countryState.countryList = payload;
			countryState.countryListLoading = false;
		},

		// ============ Country management (reference table) ============
		getCountryPagedListRequest: (state, action: PayloadAction<TCountryManagementRequest>) => {
			state.countryPagedListLoading = true;
			state.countryLastListParams = action.payload;
		},
		getCountryPagedListSuccess: (state, action: PayloadAction<TCountryPagedListResponse>) => {
			state.countryPagedList = action.payload;
			state.countryPagedListLoading = false;
		},
		getCountryPagedListFailure: (state) => {
			state.countryPagedListLoading = false;
		},

		getCountryDetailsRequest: (state, _action: PayloadAction<TCountryIdRequest>) => {
			state.countryDetailsLoading = true;
		},
		getCountryDetailsSuccess: (state, action: PayloadAction<TCountryDetails>) => {
			state.countryDetails = action.payload;
			state.countryDetailsLoading = false;
		},
		getCountryDetailsFailure: (state) => {
			state.countryDetailsLoading = false;
		},
		clearCountryDetails: (state) => {
			state.countryDetails = null;
		},

		updateCountryRequest: (state, _action: PayloadAction<TUpdateCountryRequest>) => {
			state.countrySaveLoading = true;
			state.countrySaveSuccess = false;
		},
		saveCountrySuccess: (state) => {
			state.countrySaveLoading = false;
			state.countrySaveSuccess = true;
		},
		saveCountryFailure: (state) => {
			state.countrySaveLoading = false;
		},
		resetSaveCountrySuccess: (state) => {
			state.countrySaveSuccess = false;
		},

		countryInitState: () => initialState,
	},
});

export default country.reducer;
export const {
	getCountryListRequest,
	getCountryListSuccess,
	getCountryPagedListRequest,
	getCountryPagedListSuccess,
	getCountryPagedListFailure,
	getCountryDetailsRequest,
	getCountryDetailsSuccess,
	getCountryDetailsFailure,
	clearCountryDetails,
	updateCountryRequest,
	saveCountrySuccess,
	saveCountryFailure,
	resetSaveCountrySuccess,
	countryInitState,
} = country.actions;
